import { NotificationKind } from 'carbon-components-react';
import { createStore } from 'effector';
import { loadNotificationsEV, pushNotificationEV } from './events';

export interface Notification {
  code: string;
  content: string;
  level: NotificationKind;
  translations: NotificationTranslation[];
  internal?: boolean;
}

export interface NotificationTranslation {
  [key: string]: string;
}

interface PortalNotificationsStore {
  notifications?: Notification[];
}

const defaultState: PortalNotificationsStore = {
  notifications: [],
};

export const $portalNotificationsStore = createStore<PortalNotificationsStore>(defaultState)
  .on(loadNotificationsEV, (state, payload) => {
    const existingCodes = new Set(state.notifications?.map((n) => n.code));
    const newNotifs = payload.filter(
      (notificaiton: Notification) => !existingCodes.has(notificaiton.code)
    );

    if (!newNotifs.length) {
      return state;
    }

    return { ...state, notifications: [...(state.notifications ?? []), ...newNotifs] };
  })
  .on(pushNotificationEV, (state, payload) => {
    const hasSameCode = state.notifications?.some(
      (notification: Notification) => notification.code === payload.code
    );

    if (hasSameCode) {
      return state;
    }

    return { ...state, notifications: [...(state.notifications ?? []), payload] };
  });
